import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u65E5\u672C\u8A9E",
  code: "ja",
  messages: {
    alert: {
      close: "\u9589\u3058\u308B"
    },
    authForm: {
      hidePassword: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u96A0\u3059",
      showPassword: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u8868\u793A",
      submit: "\u7D9A\u3051\u308B"
    },
    banner: {
      close: "\u9589\u3058\u308B"
    },
    calendar: {
      nextMonth: "\u7FCC\u6708",
      nextYear: "\u7FCC\u5E74",
      prevMonth: "\u524D\u6708",
      prevYear: "\u524D\u5E74"
    },
    carousel: {
      dots: "\u8868\u793A\u3059\u308B\u30B9\u30E9\u30A4\u30C9\u3092\u9078\u629E",
      goto: "\u30B9\u30E9\u30A4\u30C9 {slide} \u306B\u79FB\u52D5",
      next: "\u6B21\u3078",
      prev: "\u524D\u3078"
    },
    chatPrompt: {
      placeholder: "\u3053\u3053\u306B\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044..."
    },
    chatPromptSubmit: {
      label: "\u9001\u4FE1"
    },
    colorMode: {
      dark: "\u30C0\u30FC\u30AF",
      light: "\u30E9\u30A4\u30C8",
      switchToDark: "\u30C0\u30FC\u30AF\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
      switchToLight: "\u30E9\u30A4\u30C8\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
      system: "\u30B7\u30B9\u30C6\u30E0"
    },
    commandPalette: {
      back: "\u623B\u308B",
      close: "\u9589\u3058\u308B",
      noData: "\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093",
      noMatch: "\u4E00\u81F4\u3059\u308B\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093",
      placeholder: "\u30B3\u30DE\u30F3\u30C9\u3092\u5165\u529B\u3059\u308B\u304B\u691C\u7D22..."
    },
    contentSearch: {
      links: "\u30EA\u30F3\u30AF",
      theme: "\u30C6\u30FC\u30DE"
    },
    contentSearchButton: {
      label: "\u691C\u7D22..."
    },
    contentToc: {
      title: "\u3053\u306E\u30DA\u30FC\u30B8\u5185"
    },
    dashboardSearch: {
      theme: "\u30C6\u30FC\u30DE"
    },
    dashboardSearchButton: {
      label: "\u691C\u7D22..."
    },
    dashboardSidebarCollapse: {
      collapse: "\u30B5\u30A4\u30C9\u30D0\u30FC\u3092\u6298\u308A\u305F\u305F\u3080",
      expand: "\u30B5\u30A4\u30C9\u30D0\u30FC\u3092\u5C55\u958B"
    },
    dashboardSidebarToggle: {
      close: "\u30B5\u30A4\u30C9\u30D0\u30FC\u3092\u9589\u3058\u308B",
      open: "\u30B5\u30A4\u30C9\u30D0\u30FC\u3092\u958B\u304F"
    },
    error: {
      clear: "\u30DB\u30FC\u30E0\u306B\u623B\u308B"
    },
    fileUpload: {
      removeFile: "{filename}\u3092\u524A\u9664"
    },
    header: {
      close: "\u30E1\u30CB\u30E5\u30FC\u3092\u9589\u3058\u308B",
      open: "\u30E1\u30CB\u30E5\u30FC\u3092\u958B\u304F"
    },
    inputMenu: {
      create: '"{label}"\u3092\u4F5C\u6210',
      noData: "\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093",
      noMatch: "\u4E00\u81F4\u3059\u308B\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093"
    },
    inputNumber: {
      decrement: "\u6E1B\u3089\u3059",
      increment: "\u5897\u3084\u3059"
    },
    modal: {
      close: "\u9589\u3058\u308B"
    },
    pricingTable: {
      caption: "\u4FA1\u683C\u30D7\u30E9\u30F3\u306E\u6BD4\u8F03"
    },
    prose: {
      codeCollapse: {
        closeText: "\u6298\u308A\u305F\u305F\u3080",
        name: "\u30B3\u30FC\u30C9",
        openText: "\u5C55\u958B"
      },
      collapsible: {
        closeText: "\u975E\u8868\u793A",
        name: "\u30D7\u30ED\u30D1\u30C6\u30A3",
        openText: "\u8868\u793A"
      },
      pre: {
        copy: "\u30B3\u30FC\u30C9\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC"
      }
    },
    selectMenu: {
      create: '"{label}"\u3092\u4F5C\u6210',
      noData: "\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093",
      noMatch: "\u4E00\u81F4\u3059\u308B\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093",
      search: "\u691C\u7D22..."
    },
    slideover: {
      close: "\u9589\u3058\u308B"
    },
    table: {
      noData: "\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093"
    },
    toast: {
      close: "\u9589\u3058\u308B"
    }
  }
});
